module.exports = __webpack_public_path__ + "static/image-retirement-82fd5e820f4085edd5a866c3fc44070c.jpg";